module.exports = __webpack_public_path__ + "static/img/icon_live_void.409aebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_live_void.png
// module id = PmRG
// module chunks = 1